const botUserAgents = [
        /Googlebot/i,
        /InspectionTool/i,
        /Bingbot/i,
        /Slurp/i,
        /DuckDuckBot/i,
        /Baiduspider/i,
        /YandexBot/i,
        /Sogou/i,
        /Exabot/i,
        /facebot/i, // Facebook bot
        /Twitterbot/i,
        /MJ12bot/i, // Majestic bot
        /AhrefsBot/i,
        /SemrushBot/i,
        /Bot/i, // Generic bot detection
        /Spider/i,
        /Crawler/i
    ];

 export const isBot = () => {
        return botUserAgents.some(regex => regex.test(navigator.userAgent));
    }